import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-tickets-lumat',
    imports: [],
    templateUrl: './tickets-lumat.component.html',
    styleUrl: './tickets-lumat.component.scss'
})
export class TicketsLumatComponent implements OnInit {
    urlSafe!: SafeResourceUrl;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl('https://tickets.lumat.com.py/');
    }
}
